import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Button,
  Form,
  Row,
  Col,
  Table,
  Modal,
} from "@themesberg/react-bootstrap";
import PaginationComponent from "../../../components/Pagination";
import CreateCasinoGames from "./components/CreateCasinoGames";
import ConfirmationModal from "../../../components/ConfirmationModal";
import useCasinoGamesListing from "./hooks/useCasinoGamesListing";
import Trigger from "../../../components/OverlayTrigger";
import { tableHeaders } from "./constants";
import useCheckPermission from "../../../utils/checkPermission";
import ActionMenu from "./ActionMenu";
import CasinoBonusModal from "../../../components/CasinoBonus";
import NotificationIconContainer from "../../../components/NotificationIcon/NotificationIconContainer";
import { ThumbnailModalContent, ThumbnailPreview } from "./style";
import { CustomCol } from "../TransactionsBanking/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt, faFileDownload } from "@fortawesome/free-solid-svg-icons";
import ImageModal from "../../../components/ImageModal";

import useTableCustom from "../../../components/CusotmFilter"
import TableErrorMessage from "../../../components/TableErrorMessage"
import AssignCategoryModal from "./components/AssingCategoryModal";



export default () => {
  const {
    limit,
    page,
    selectedSubCategoryId,
    show,
    data,
    type,
    statusShow,
    setLimit,
    setPage,
    setSelectedSubCategoryId,
    setStatusShow,
    gameSubCategory,
    casinoGamesData,
    totalPages,
    handleStatusShow,
    handleYes,
    handleClose,
    handleShow,
    loading,
    getCategoryName,
    search,
    setSearch,
    active,
    setActive,
    status,
    getProviderName,
    navigate,
    setSelectedProvider,
    selectedProvider,
    createCategory,
    updateCategory,
    handleDeleteItems,
    handlePopular,
    handleNewGame,
    handleActive,
    name,
    casinoBonusModal,
    setCasinoBonusModal,
    selectedCasinoGameId,
    setSelectedCasinoGameId,
    bonusFilter,
    setBonusFilter,
    thumbnailModal,
    selectedGameForThumbnail,
    thumbnailUrl,
    thumbnailPreview,
    isUpdatingThumbnail,
    handleThumbnailModalOpen,
    handleThumbnailModalClose,
    handleThumbnailUrlChange,
    handlePreviewThumbnail,
    handleUpdateThumbnail,
    onhanldereset,
    setImageModal,
    imageModal,
    setPopularModal,
    popularModal,
    handlePopularYes,
    categoryDropdownOptions,
    handleUpdateCategoryChange,
    selectedCategoryOption,
    isOpenAssignCategoryModal, setIsOpenAssignCategoryModal,
    onSubmitAddCasinoGameCategory,
    loadingAddCategory,
    setSelectedctegoryOptions,
    isEnanbleAssignCategory, totalCount
  } = useCasinoGamesListing();
  const { isHidden } = useCheckPermission();
  const [casinoGame, setCasinoGame] = useState({});

  const isShowActionColumnCG =
    !isHidden({ module: { key: "CasinoManagement", value: "U" } }) ||
    !isHidden({ module: { key: "CasinoManagement", value: "T" } });
  const isUpdate = !isHidden({ module: { key: "CasinoManagement", value: "U" } })
  const isToggle = !isHidden({ module: { key: "CasinoManagement", value: "T" } });

  const dynamicTableHeaders = useMemo(() => {
    const headers = [...tableHeaders.filter(col => col.value !== 'action')];
    if (isShowActionColumnCG) {
      headers.push({
        accessorKey: 'action',
        Header: 'Actions',
        value: 'action',
        label: 'Actions',
      });
    }

    return headers;
  }, [isShowActionColumnCG]);

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
  } = useTableCustom(
    casinoGamesData?.rows,
    dynamicTableHeaders, // already permission-filtered
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "CASINO_GAMES"
  );

  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState("");

  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 100;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
        setTableMaxHeight(`${availableHeight}px`);
      }


    };

    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [visibleColumns, tableHeaders]);

  return (
    <>
      <div className="section-header-wrap mt-n3 mx-n3" ref={headerRef}>
        <Row className="align-items-center justify-content-between">
          <Col lg={8} xs={7}>
            <h2 className="title-text">Casino Games</h2>
          </Col>
          <Col xs={2} className="text-end">
            <NotificationIconContainer />
          </Col>
        </Row>
      </div>
      <div className="FormsBg" ref={filterRef}>
        <Row className="gy-2">
          <CustomCol>
            <Form.Control
              type="search"
              value={search}
              placeholder="Search by name"
              onChange={(event) =>
                setSearch(
                  event.target.value.replace(/[~`!$%^&*#=)()><?]+/g, "")
                )
              }
            />
          </CustomCol>

          <CustomCol>
            <Form.Select
              onChange={(e) => {
                setActive(e.target.value);
              }}
              value={active}
            >
              <option value="" hidden aria-hidden>Filter by status</option>
              <option value="">All</option>
              <option value="true">Active</option>
              <option value="false">In-Active</option>
            </Form.Select>
          </CustomCol>
          <CustomCol>
            <Form.Select
              onChange={(e) => {
                setBonusFilter(e.target.value);
              }}
              value={bonusFilter}
            >
              <option value="" hidden aria-hidden>Filter by bonus status</option>
              <option value="">All</option>
              <option value="ACTIVE">Active</option>
              <option value="IN_ACTIVE">In Active</option>
              <option value="EXPIRED">Expired</option>
            </Form.Select>
          </CustomCol>
        </Row>
        <Row className="g-2 align-items-center mt-2 mt-md-0">
          <Col xs={12}>
            <div className="d-flex flex-column flex-md-row justify-content-between gap-2 w-100">
              {/* Reset Button */}
              <Button
                className="d-flex align-items-center btn-primary gap-3"
                style={{ height: '2.2rem', minWidth: 'max-content' }}
                size="sm"
                onClick={onhanldereset}
              >
                <span>Reset Filters</span>
                <FontAwesomeIcon icon={faRedoAlt} />
              </Button>

              {/* Column Visibility Dropdown or Setting */}
              <div>{customColSetting}</div>
            </div>
          </Col>
        </Row>

      </div>
      {visibleColumns?.length > 0 ? <div className="TableBg mt-4 pt-1">

        <Table striped responsive hover size="sm" className="text-center mt-3">
          <thead className="thead-light">
            <tr>
              {visibleColumns.map((col, idx) => (
                <th key={idx} className={`${col.value === "returnToPlayer" ? "text-left" : ""}`}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody id={loading ? "cover-spin" : ""}>
            {!loading &&
              casinoGamesData?.rows?.length > 0 &&
              casinoGamesData.rows.map((row, indx) => (
                <tr key={row.casinoGameId}>
                  {visibleColumns.map((col, cIdx) => {
                    const key = col.accessorKey;
                    const value = row[key];
                    switch (key) {
                      case "name":
                      case "categoryname":

                        return (
                          <td key={cIdx}>
                            <Trigger message={value}>
                              <span
                                style={{ width: "200px", cursor: "pointer" }}
                                className="d-inline-block text-truncate"
                              >
                                {value}
                              </span>
                            </Trigger>
                          </td>
                        )

                      case "thumbnails":
                        const thumbnailData = row?.videoSnapshot;
                        const thumbUrl = thumbnailData?.evolutionImage
                          ? `${process.env.REACT_APP_S3_URL}/${thumbnailData.evolutionImage}`
                          : thumbnailData?.thumbnails?.XL
                            ? thumbnailData.thumbnails.XL
                            : thumbnailData?.links?.XL
                              ? `${process.env.REACT_APP_EVOLUTION_URL}${thumbnailData.links.XL}`
                              : null;
                        return (
                          <td key={cIdx}>
                            {thumbUrl ? (
                              <span
                                onClick={() => setImageModal({
                                  isOpen: true,
                                  url: thumbUrl,
                                })}

                                // onClick={() => window.open(thumbUrl)}
                                className="text-link"
                                style={{ cursor: "pointer" }}
                              >
                                <img src={`${thumbUrl}`}
                                  style={{ width: '100px', height: 'auto', objectFit: 'contain', cursor: 'pointer' }}
                                />
                              </span>
                            ) : (
                              "--"
                            )}
                          </td>
                        );


                      case "isActive":
                        return (
                          <td key={cIdx}>
                            {value ? (
                              <span className="text-success">Active</span>
                            ) : (
                              <span className="text-danger">Inactive</span>
                            )}
                          </td>
                        );

                      case "newGame":
                        return (
                          <td key={cIdx}>
                            {value ? (
                              <span className="text-success">True</span>
                            ) : (
                              <span className="text-danger">False</span>
                            )}
                          </td>
                        );

                      case "isPopular":
                        return (
                          <td key={cIdx}>
                            {value ? (
                              <span className="text-success">Trending</span>
                            ) : (
                              <span className="text-danger">Not Trending</span>
                            )}
                          </td>
                        );

                      case "action":
                        return (
                          <td key={cIdx}>
                            <ActionMenu
                              isHidden={isHidden}
                              handleShow={handleShow}
                              isPopular={row.isPopular}
                              newGame={row.newGame}
                              name={row.name}
                              indx={indx}
                              handleStatusShow={handleStatusShow}
                              casinoGamesData={casinoGamesData}
                              casinoGameId={row.casinoGameId}
                              casinoBonus={{
                                bonusStatus: row.bonusStatus,
                                bonus: row.bonus,
                                ...row.moreDetails?.[0],
                              }}
                              handleDeleteItems={handleDeleteItems}
                              navigate={navigate}
                              handlePopular={handlePopular}
                              handleNewGame={handleNewGame}
                              casinoPopularId={row.casinoGameId}
                              isActive={row.isActive}
                              handleActive={handleActive}
                              casinoBonusModal={casinoBonusModal}
                              setCasinoBonusModal={setCasinoBonusModal}
                              setSelectedCasinoGameId={setSelectedCasinoGameId}
                              setCasinoGame={setCasinoGame}
                              setPopularModal={setPopularModal}
                              handleThumbnailModalOpen={() =>
                                handleThumbnailModalOpen({
                                  casinoGameId: row.casinoGameId,
                                  name: row.name,
                                  thumbnailUrl: row.
                                    videoSnapshot?.thumbnails,
                                })
                              }
                              setIsOpenAssignCategoryModal={setIsOpenAssignCategoryModal}
                            />
                          </td>
                        );

                      default:
                        return <td key={cIdx}>{value ?? "--"}</td>;
                    }
                  })}
                </tr>
              ))}

            {casinoGamesData?.count === 0 && !loading && (
              <tr>
                <td colSpan={visibleColumns.length} className="text-danger text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>



        {casinoGamesData?.count !== 0 && !loading && (
          <PaginationComponent
            page={casinoGamesData?.count < page ? setPage(1) : page}
            totalPages={totalPages}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            paginationRef={paginationRef}

            showTotalCount={true}
            totalCount={totalCount}
            countText={"Total Casino Games : "}

          />
        )}
      </div> :

        <TableErrorMessage />

      }

      <ConfirmationModal
        setShow={setStatusShow}
        show={statusShow}
        handleYes={handleYes}
        active={status}
        name={name}
      />
      <CasinoBonusModal
        show={casinoBonusModal}
        handleClose={() => {
          setCasinoGame({});
          setCasinoBonusModal(!casinoBonusModal);
        }}
        id={selectedCasinoGameId}
        casinoGameBonus={casinoGame}
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{type} Casino Game</Modal.Title>
        </Modal.Header>

        <CreateCasinoGames
          handleClose={handleClose}
          data={data}
          limit={limit}
          pageNo={page}
          gameSubCategory={gameSubCategory}
          createProvider={createCategory}
          updateProvider={updateCategory}
        />
      </Modal>

      {/* Thumbnail Update Modal */}
      <Modal
        show={thumbnailModal}
        onHide={handleThumbnailModalClose}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedGameForThumbnail
              ? `Update Thumbnail: ${selectedGameForThumbnail.name}`
              : "Update Thumbnail URL"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThumbnailModalContent>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>New Thumbnail URL</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter thumbnail URL"
                  value={thumbnailUrl}
                  onChange={handleThumbnailUrlChange}
                />
                <Form.Text className="text-muted">
                  Enter a valid URL for the game thumbnail image.
                </Form.Text>
              </Form.Group>
              <Button
                variant="secondary"
                onClick={handlePreviewThumbnail}
                disabled={!thumbnailUrl.trim()}
                className="mb-3"
              >
                Preview
              </Button>
            </Form>

            <ThumbnailPreview>
              {thumbnailPreview ? (
                <img
                  src={thumbnailPreview}
                  alt="Thumbnail Preview"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://via.placeholder.com/300x200?text=Invalid+Image+URL";
                  }}
                />
              ) : (
                <div className="placeholder">
                  Thumbnail preview will appear here
                </div>
              )}
            </ThumbnailPreview>
          </ThumbnailModalContent>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleThumbnailModalClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleUpdateThumbnail}
            disabled={isUpdatingThumbnail || !thumbnailUrl.trim()}
          >
            {isUpdatingThumbnail ? "Updating..." : "Update Thumbnail"}
          </Button>
        </Modal.Footer>
      </Modal>

      <ImageModal
        show={imageModal.isOpen}
        imageUrl={imageModal.url}
        altText="Preview"
        setShow={() => setImageModal({ ...imageModal, isOpen: false, url: '' })}
      />

      {/* for popular */}
      <ConfirmationModal
        setShow={setPopularModal}
        show={popularModal.isOpen}
        handleYes={() => handlePopular({

          data: { casinoPopularId: popularModal?.casinoPopularId },
          isPopular: popularModal?.isPopular,
          from: "casino_page",


        })}
        title={"Casino Games"}

        subTitle={`Are you sure want to make this ${popularModal.name} game as ${!popularModal.isPopular ? "Trending" : "Non-Trending"} ?`}
        name={popularModal.name}
      />
      <AssignCategoryModal options={categoryDropdownOptions} handleUpdateCategoryChange={handleUpdateCategoryChange}
        selectedCategoryOption={selectedCategoryOption} showModal={isOpenAssignCategoryModal?.isOpen} onHide={() => {
          setIsOpenAssignCategoryModal({ isOpen: false, selectedData: "" })
          setSelectedctegoryOptions("")
        }}
        onSubmitAddCasinoGameCategory={onSubmitAddCasinoGameCategory} loading={loadingAddCategory} isEnanbleAssignCategory={isEnanbleAssignCategory}
      />

    </>


  );
};
